import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const LOCALE_KEY = 'localeLanguage'
const DEFAULT_LANG = 'zh'

const locales = {
  zh: require('./zh.json'),
  en: require('./en.json')
}

const i18n = new VueI18n({
  locale: DEFAULT_LANG,
  messages: locales
})

export const setup = lang => {
  window.localStorage.setItem(LOCALE_KEY, DEFAULT_LANG)
  Vue.config.lang = DEFAULT_LANG
  i18n.locale = DEFAULT_LANG
}

setup()
export default i18n



// WEBPACK FOOTER //
// ./src/widgets/i18n/index.js